<script lang="ts">
	import Course from '$lib/components/general/course.svelte';
	import * as Card from '$lib/components/ui/card';

	let { data } = $props();
</script>

<main class="my-16 flex flex-col gap-16">
	<h1 class="text-2xl font-semibold md:text-4xl">{data.locationGroup.name}</h1>

	<div class="flex flex-col gap-4">
		<h2 class="text-xl font-semibold md:text-2xl">Standorte in {data.locationGroup.name}</h2>
		<div class="flex flex-wrap gap-4">
			{#each data.locationGroup.locations as location}
				<Card.Root class="max-w-fit shadow-none">
					<Card.Header class="pb-6">
						<Card.Title level={3} class="text-base">{location.name}</Card.Title>
						<Card.Description>
							<a
								href="https://maps.google.com/?q={location.street} {location.houseNumber}, {location.postalCode} {location.city}"
								target="_blank"
								class="underline"
							>
								{location.street}
								{location.houseNumber}, {location.postalCode}
								{location.city}
							</a>
						</Card.Description>
					</Card.Header>
				</Card.Root>
			{/each}
		</div>
	</div>

	<div class="flex flex-col gap-4">
		<h2 class="text-xl font-semibold md:text-2xl">Ausbildungen in {data.locationGroup.name}</h2>
		<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
			{#each data.courseOfferingsData as course}
				<Course data={course} sportspass={false} />
			{:else}
				<div class="bg-secondary rounded-md flex flex-1 col-span-full py-10 px-6">
					Aktuell haben wir in {data.locationGroup.name} leider keine Ausbildungen terminiert. Schaue
					später noch einmal vorbei.
				</div>
			{/each}
		</div>
	</div>
</main>
